import React from 'react'
import './Get_in_touch.css'
import { Link } from 'react-router-dom'

const Get_in_touch = () => {
  return (
    <>
      <section className='Get_in_touch'>
        <div className='container'>
          <div className='img_div'>
            <Link to='/registration'>
              <img className='bannerimg' src={process.env.PUBLIC_URL + '/assets/images/home/get-touch/banner.png'} />
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default Get_in_touch